import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";

export const Verify_services_status = async (servicetablename) => {

  // Validate input
  if (!servicetablename || !servicetablename.trim()) {
    return { success: false, error: "Missing servicetablename" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {
    const CollectionRef = collection(
      db,
      "companies",
      select_company_uid,
      servicetablename
    );

    const QueryRef = query(
      CollectionRef 
    );

    const Snap = await getDocs(QueryRef);

    if (Snap.empty) {
      return { success: false, error: "Account is not exist" };
    }

    const docData = Snap.docs[0].data();
    return { success: true, data: docData };

  } catch (err) {
    return { success: false, error: err.message || "Unknown error" };
  }
};
